var SeatVariant;
(function (SeatVariant) {
    SeatVariant["ACCESSIBLE"] = "ACCESSIBLE";
    SeatVariant["AISLE"] = "AISLE";
    SeatVariant["AVAILABLE"] = "AVAILABLE";
    SeatVariant["COLUMN"] = "COLUMN";
    SeatVariant["EXIT"] = "EXIT";
    SeatVariant["GALLEY"] = "GALLEY";
    SeatVariant["PREFERRED"] = "PREFERRED";
    SeatVariant["RESTROOM"] = "RESTROOM";
    SeatVariant["ROW"] = "ROW";
    SeatVariant["SELECTED"] = "SELECTED";
    SeatVariant["UNAVAILABLE"] = "UNAVAILABLE";
})(SeatVariant || (SeatVariant = {}));

export { SeatVariant };
